import { createSelector } from 'reselect'

import { getApiTasks } from '../api/selectors'
import { getSelectedTopicId } from '../selected/selectors'

export const getSelectedTopicTasks = createSelector(
  [getSelectedTopicId, getApiTasks],
  (topicId, tasks) => {
    return Object.values(tasks).filter((task) => task.topic_id === topicId)
  },
)

export const makeGetTask = () =>
  createSelector([getApiTasks, (_, id) => id], (tasks, id) => {
    return tasks[id]
  })
